<template>
  <div class="flex flex-col w-full">
    <NextButton
      v-if="!waba_id"
      class="ml-2"
      icon="i-lucide-facebook"
      label="Conectar WhatsApp"
      @click="launchWhatsAppSignup"
    />
    <!--<div v-if="waba_id" class="flex flex-col mt-4">
      <NextButton
        class="mt-2"
        icon="i-lucide-check"
        label="Request Code"
        @click="requestCode()"
      />
    </div>-->
    <form
      v-if="waba_id"
      class="flex flex-col w-full"
      @submit.prevent="createChannel"
    >
      <div class="flex flex-col mt-4">
        <label for="">Channel Name</label>
        <InputText v-model="channel_name" class="w-full" type="text" />
      </div>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import router from '../../../../../index';
import axios from 'axios';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useAlert } from 'dashboard/composables';
import { ca } from 'date-fns/locale';

const route = useRoute();
const accountId = route.params.accountId;
const store = useStore();
const { t } = useI18n();

const uiFlags = computed(() => store.getters['inboxes/getUIFlags']);
const channel_name = ref(null);
const phone_number = ref(null);
const phone_number_id = ref(null);
const waba_id = ref(null);
const token_response = ref(null);
const webhook_verify_token = ref(null);
const detailsPhone = ref(null);

const launchWhatsAppSignup = () => {
  FB.login(
    response => {
      if (response.authResponse) {
        const { accessToken, userID } = response.authResponse;
        token_response.value = accessToken;
        handleFacebookLogin(accessToken);
      } else {
        useAlert('El usuario canceló el proceso de conexión');
      }
    },
    {
      scope:
        'business_management,whatsapp_business_management,whatsapp_business_messaging,pages_messaging',
      extras: {
        feature: 'whatsapp_embedded_signup',
        version: 3,
        setup_mode: 'embedded',
        sessionInfoVersion: '2',
      },
    }
  );
};

async function handleFacebookLogin(token) {
  try {
    const data = {
      access_token: token,
      accountId: accountId,
    };
    const exchangeResult = await store.dispatch(
      'inboxes/exchangeAccessToken',
      data
    );
    if (exchangeResult && exchangeResult.access_token) {
      token_response.value = exchangeResult.access_token;
    }

    // Espera a que phone_number_id y waba_id estén definidos
    if (!phone_number_id.value || !waba_id.value) {
      useAlert('Faltan datos de WhatsApp (phone_number_id o waba_id)');
      return;
    }

    const params = {
      fields: 'display_phone_number,verified_name',
      phone_number_id: phone_number_id.value,
      access_token: token_response.value,
      accountId: accountId,
    };
    detailsPhone.value = await store.dispatch(
      'inboxes/fetchPhoneNumberDetails',
      params
    );
    if (detailsPhone.value) {
      channel_name.value = detailsPhone.value.verified_name;
      phone_number.value = detailsPhone.value.display_phone_number
        ?.toString()
        .replace(/\s/g, '');
    }
  } catch (error) {
    useAlert(error.message || 'Error al intercambiar el token');
  }
}

function generateHexToken(length = 16) {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
}

// 5. Crear canal en Chatwoot
const createChannel = async () => {
  try {
    if (!token_response.value || !phone_number_id.value || !waba_id.value) {
      throw new Error('Configuración incompleta de WhatsApp');
    }

    if (!detailsPhone.value) {
      throw new Error('Error al obtener detalles del número de teléfono');
    }
    webhook_verify_token.value = generateHexToken(16);
    const channelConfig = {
      name: `WhatsApp - ${channel_name.value}`,
      channel: {
        type: 'whatsapp',
        phone_number: phone_number.value,
        provider: 'whatsapp_cloud',
        provider_config: {
          api_key: token_response.value,
          phone_number_id: phone_number_id.value,
          business_account_id: waba_id.value,
          webhook_url: `https://testpchat.performlab.co/webhooks/whatsapp/${phone_number.value}`,
          webhook_verify_token: webhook_verify_token.value,
        },
      },
    };

    const whatsappChannel = await store.dispatch(
      'inboxes/createChannel',
      channelConfig
    );
    if (whatsappChannel) {
      router.replace({
        name: 'settings_inboxes_add_agents',
        params: {
          page: 'new',
          inbox_id: whatsappChannel.id,
        },
      });
      useAlert('Canal de WhatsApp creado exitosamente', 'success');
    }
  } catch (error) {
    console.error('Error creando canal:', error);
    useAlert(error.message || 'Error al crear el canal');
  }
};

window.addEventListener('message', event => {
  if (
    event.origin !== 'https://www.facebook.com' &&
    event.origin !== 'https://web.facebook.com'
  ) {
    return;
  }
  try {
    const data = JSON.parse(event.data);
    if (data.type === 'WA_EMBEDDED_SIGNUP') {
      // if user finishes the Embedded Signup flow
      if (data.event === 'FINISH') {
        phone_number_id.value = data.data.phone_number_id;
        waba_id.value = data.data.waba_id;

        console.log('Data :::: ', data.data);
        // if user cancels the Embedded Signup flow
      } else if (data.event === 'CANCEL') {
        const { current_step } = data.data;
        console.warn('Cancel at ', current_step);
        // if user reports an error during the Embedded Signup flow
      } else if (data.event === 'ERROR') {
        const { error_message } = data.data;
        console.error('error ', error_message);
      }
    }
  } catch {
    console.log('Non JSON Responses', event.data);
  }
});

// Inicialización
onMounted(async () => {
  window.fbAsyncInit = function () {
    FB.init({
      appId: '1087562195602449',
      autoLogAppEvents: true,
      cookie: true,
      xfbml: true,
      version: 'v20.0',
    });

    FB.AppEvents.logPageView();
  };

  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
});
</script>